<div class="leaderboard">
  <span class="leader-heading">Leaderboard</span>
  <div class="selected-div">
    <select (change)="onOptionSelected($event)" class="select-form">
      <option value="">Select an option</option>
      <option value="option1">Option 1</option>
      <option value="option2">Option 2</option>
      <option value="option3">Option 3</option>
    </select>
  </div>

  <div class="table-admin">
    <div class="d-flex align-items-center" style="width: 100%">
      <div class="admin-heading">District admins</div>
      <!-- <div class="full-table" (click)="onClickFullTable()">Full table</div> -->
    </div>
    <div class="table-container">
      <table class="leader-table">
        <tbody>
          <!-- @for (items of adminData; track items.username) { -->
          <tr *ngFor="let item of adminData">
            <td>
              <div class="d-flex align-items-center">
                <span
                  ><img
                    class="person-img"
                    src="../../../../assets/images/profilePic.png"
                    alt="Image"
                    width="44"
                    height="44"
                /></span>
                <div class="ms-2">
                  <span class="user-name">{{ item.username }}</span
                  ><br />
                  <span class="location">{{ item.location }}</span>
                </div>
                <span class="points ms-auto">{{ item.points }}</span>
              </div>
            </td>
          </tr>
          <!-- } -->
        </tbody>
      </table>
    </div>

    <div class="d-flex align-items-center" style="width: 100%">
      <div class="admin-heading">Field workers</div>
      <!-- <div class="full-table">Full table</div> -->
    </div>
    <div class="table-container">
      <table class="leader-table">
        <tbody>
          <!-- @for (items of adminData; track items.username) { -->
          <tr *ngFor="let item of adminData">
            <td>
              <div class="d-flex align-items-center">
                <span
                  ><img
                    class="person-img"
                    src="../../../../assets/images/profilePic.png"
                    alt="Image"
                    width="44"
                    height="44"
                /></span>
                <div class="ms-2">
                  <span class="user-name">{{ item.username }}</span
                  ><br />
                  <span class="location">{{ item.location }}</span>
                </div>
                <span class="points">{{ item.points }}</span>
              </div>
            </td>
          </tr>
          <!-- } -->
        </tbody>
      </table>
    </div>
  </div>
</div>
